import React from 'react';

import {useStore} from 'effector-react';
import {Location} from 'history';
import {RouteProps} from 'react-router';
import {Redirect, Route} from 'react-router-dom';

import {ROUTE} from 'core/routes';
import {$mainRole, isAuth$, permissions$, profile$} from 'models/auth';
import {UserPermission, UserRoles} from 'types';

import {hasAccess} from 'utils/roles';

interface Props extends RouteProps {
    permissions?: UserPermission[];
    permissionAccessRoles?: UserRoles[];
    roles?: UserRoles[];
}

export function PrivateRoute({
    children,
    permissions,
    permissionAccessRoles,
    roles,
    path,
    ...rest
}: Props) {
    const isAuth = useStore(isAuth$);
    const profile = useStore(profile$);
    const currentPermissions = useStore(permissions$);
    const mainRole = useStore($mainRole);

    const hasNoAccessByRole =
        !mainRole || !permissionAccessRoles || !permissionAccessRoles.includes(mainRole);

    const renderContent = (location: Location) => {
        if (!isAuth) return <Redirect to={{pathname: ROUTE.LOGIN, state: {from: location}}} />;

        if (
            path !== ROUTE.NO_ACCESS &&
            !hasAccess(currentPermissions, permissions) &&
            hasNoAccessByRole
        )
            return <Redirect to={{pathname: ROUTE.NO_ACCESS, state: {from: location}}} />;

        if (roles && !roles?.some((elem) => profile!.roles?.includes(elem)))
            return <Redirect to={{pathname: ROUTE.NO_ACCESS, state: {from: location}}} />;

        return children;
    };

    return <Route {...rest} render={({location}) => renderContent(location)} />;
}
